import Slides from '../slides/Slides';
const Compromiso = ({M}) => {
   return (
      <>
         <Slides M={M} tipoSlides="compromiso"/>
         <div className="section white py-5 animated fadeIn">
            <div className="container">
               
               {/* TÍTULO PRINCIPAL */}
               <div className="row center mb-4">
                  <h4 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600' }}>
                     ¿Por qué elegir a Latitud Sur?
                  </h4>
               </div>

               {/* TARJETA 1: INTRODUCCIÓN */}
               <div className="row justify-content-center mb-5">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           La elección de una compañía de seguros, sin duda, no es una cuestión menor. En casos de siniestros, esta deberá responder por los daños patrimoniales sufridos, o los que Ud. provoque a terceros; por ello es necesario contar con la certidumbre de los beneficios y ventajas que la misma ofrecerá.
                        </p>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           El contrato de seguro no es algo tangible. Es un servicio a futuro y eventual, con el cual muchos, erróneamente, lo juzgan como un gasto.
                        </p>
                     </div>
                  </div>
               </div>

               {/* SUBTÍTULO: ¿CÓMO ELEGIR... */}
               <div className="row center mb-4">
                  <h5 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600', fontSize: '1.8rem' }}>
                     ¿Cómo elegir a la aseguradora correcta?
                  </h5>
               </div>

               {/* TARJETA 2: VARIABLES DE ELECCIÓN */}
               <div className="row justify-content-center mb-5">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Para una elección correcta, además de los beneficios específicos de cada seguro, deben analizarse ciertas variables que conjugadas permitirán decidir entre una y otra aseguradora. En términos generales, estas variables son la <u>estabilidad económica</u> y el patrimonio neto de la aseguradora, el <u>precio</u> y la <u>atención al cliente</u>.
                        </p>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           A comienzo del año 2000 se inició una nueva etapa, empezando a ofrecer nuestros servicios fuera del sector tabacalero jujeño. El proceso de crecimiento fue lento pero continuo, protegiendo el capital de nuestros accionistas y siendo muy cautelosos en la asunción de riesgos. Hoy somos la Aseguradora de Riesgos del Trabajo N° 1 de la Provincia de Jujuy y la N° 3 de la Provincia de Salta en cuanto al total de trabajadores asegurados.
                        </p>
                     </div>
                  </div>
               </div>

               {/* ESTABILIDAD ECONÓMICA */}
               <div className="row center mb-4">
                  <h6 className="grey-text text-darken-4 institutional-title" style={{ fontWeight: '600', fontSize: '1.5rem' }}>
                     Estabilidad económica
                  </h6>
               </div>
               <div className="row justify-content-center mb-5">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Es importante que la empresa aseguradora contratada tenga la solvencia suficiente para hacer efectiva la indemnización en caso de siniestro. En este caso las revistas especializadas o el organismo controlador (Superintendencia de Seguros de la Nación (SSN)) pueden otorgarle información confiable sobre la calificación de las aseguradoras que operan en el mercado.
                        </p>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Según información de la{' '}
                           <a href="https://www.argentina.gob.ar/superintendencia-de-seguros" target="_blank" rel="noopener noreferrer" className="light-blue-text text-darken-2" style={{ fontWeight: '600', textDecoration: 'underline' }}>
                              Superintendencia
                           </a>
                           , Latitud Sur es la A.R.T. con mayor participación en el mercado de Riesgos del Trabajo de la Provincia de Jujuy (con un 28.9% y aproximadamente 15.000 cápitas aseguradas).
                        </p>
                     </div>
                  </div>
               </div>

               {/* PRECIO */}
               <div className="row center mb-4">
                  <h6 className="grey-text text-darken-4 institutional-title" style={{ fontWeight: '600', fontSize: '1.5rem' }}>
                     Precio
                  </h6>
               </div>
               <div className="row justify-content-center mb-5">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Varía según las compañías, las zonas de alta o baja siniestralidad y el tipo de cobertura que contrate.
                        </p>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Muchas veces, y con el fin de ahorrar algo de dinero, se descuida la calidad o el valor agregado del servicio que se adquiere. Descuido que a la larga puede acarrear más problemas y hasta la quiebra. Por eso es importante que, a la hora de analizar el precio, se analice el servicio en general. Dicho de otra forma, el análisis de esta variable debe hacerse en función del beneficio para la empresa.
                        </p>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Como las ofertas son tan disímiles, al confrontar una cotización con otra, asegúrese que se trate de la misma cobertura y calidad. En este sentido puede ponerse en contacto con nuestros clientes para que le ofrezcan todas las referencias necesarias.
                        </p>
                     </div>
                  </div>
               </div>

               {/* ATENCIÓN AL CLIENTE */}
               <div className="row center mb-4">
                  <h6 className="grey-text text-darken-4 institutional-title" style={{ fontWeight: '600', fontSize: '1.5rem' }}>
                     Atención al Cliente
                  </h6>
               </div>
               <div className="row justify-content-center">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Este aspecto es clave a la hora de la valoración. Por ello debe hacerse un análisis estratégico a corto y largo plazo.
                        </p>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           En este sentido LATITUD SUR es una aseguradora regional, enfocada en las Provincias de Jujuy y Salta. Esto representa una fuerte ventaja competitiva: tenemos una relación directa y personal con los asegurados, y sus trabajadores. Todo ello, nos permitió ser la aseguradora N° 1 de la Provincia de Jujuy y estar dentro de las cinco principales A.R.T. de la Provincia de Salta.
                        </p>
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Nuestros profesionales realizan el seguimiento directo de los accidentados. Contamos con un plantel de atención permanente en nuestras oficinas centrales.
                        </p>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           El Área de Prevención cuenta con un equipo capacitado en los más variados riesgos, esto nos permite llegar a la concientización necesaria en los empleados / obreros sobre el uso de Elementos de Protección Personal (E.P.P.). Nuestra política de compromiso es trabajar codo a codo con el empleador. En muchas ocasiones entregamos, sin cargo, ELEMENTOS DE PROTECCIÓN PERSONAL a los empleadores, con la respectiva capacitación a los trabajadores.
                        </p>
                     </div>
                  </div>
               </div>

            </div>      
         </div>
      </>
   )
}

export default Compromiso